import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import Router from 'next/router';
import { useDispatch } from 'react-redux';
import ReactLoading from 'react-loading';
import Form, { Field } from 'rc-field-form';
import { postSettled, postSendValidCode } from '@/services/settled';
import Upload from '@/components/upload';
import Checkbox from '@/components/checkbox';
import Layout from '@/layouts';
import Footer from '@/components/footer';
import { isMobilePhone } from '@/constants/regexp';
import Button from '@/components/button';
import LabelField from '@/business-components/normal-label-field';
import CountDown from '@/components/count-down';
import HeaderCard from './components/HeaderCard';
import SubmitSuccess from './components/SubmitSuccess';
import HasSubmit from './components/HasSubmit';
import styles from './index.module.scss';

// export const getServerSideProps = async ({ res }) => {
//   res.setHeader('Cache-Control', 'public, s-maxage=59, stale-while-revalidate=119');
//   return {};
// };

const emailReg =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

function InstitutionSettled() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const sendCodeHandle = useCallback(async value => {
    try {
      await postSendValidCode(value);
    } catch (error) {}
  }, []);
  // dispatch({ type: 'modal/open', payload: { content: <SubmitSuccess email="123" /> } });
  const submit = useCallback(async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const res: any = await postSettled({
        ...values,
        wechatImgBase64: values.wechatImg?.url,
        wechatImgFileName: values.wechatImg?.name,
        select: undefined,
        wechatImg: undefined,
      });
      setLoading(false);
      if (res.code !== 200) throw new Error();
      if (res.data?.hasRepeatSubmit) {
        dispatch({
          type: 'modal/open',
          payload: {
            content: <HasSubmit />,
            closeCallback: () => {
              Router.push('/cbndatabox-new');
            },
          },
        });
      } else {
        dispatch({
          type: 'modal/open',
          payload: {
            content: <SubmitSuccess />,
            closeCallback: () => {
              Router.push('/cbndatabox-new');
            },
          },
        });
      }
      //   dispatch({ type: 'modal/close' });
      //   toast.success('提交成功');
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, form]);
  return (
    <Layout
      title="Martech企服商店-企服点评平台-SaaS应用商店 | CBNData"
      description="第一财经商业数据中心（CBNData）隶属于上海文化广播影视集团（SMG），是国内领先的消费研究机构及数字化增长服务商。CBNDataBox是专业的Martech企服应用商店，围绕企业内营销流程的需求场景，为消费行业的营销&运营人员整合优质的Martech企服工具。"
      keyword="企业服务,企业服务工具,CBNData企服商店,公司点评,企服点评,SaaS商店,应用商店,大数据,SaaS服务,客户管理,营销数据,市场营销,创业服务,营销决策,管理工具"
      isShowNavBar
      FooterComponent={Footer}
      //   isFrapMain
      mainClass={styles.institutionSettled}
    >
      <div className={styles.inner}>
        <HeaderCard />
        <div className={classNames('flex-row-wrap', styles.registContent)}>
          <div className={styles.registContentLeft}>
            <div className={styles.registContentLeftTit}>入驻流程</div>
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStep)}>
              <div className={styles.registContentLeftStepLeft}>Step 1</div>
              <div className={styles.registContentLeftStepRight}>提交入驻申请信息</div>
            </div>
            <img
              className={styles.registContentLeftStepImg}
              src="https://assets-oss.cbndata.com/cbndata-refactor-fe/FovkPfUXrvbt8G8QJSqknxJhNPjB.png"
            />
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStepCont)}>
              <div className={styles.registContentLeftStepIcon}>1</div>
              <div className={styles.registContentLeftStepText}>填写对接人基础信息</div>
            </div>
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStepCont)}>
              <div className={styles.registContentLeftStepIcon}>2</div>
              <div className={styles.registContentLeftStepText}>填写产品信息表单</div>
            </div>
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStepCont)}>
              <div className={styles.registContentLeftStepIcon}>3</div>
              <div className={styles.registContentLeftStepText}>提交审核</div>
            </div>
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStep)}>
              <div className={styles.registContentLeftStepLeft}>Step 2</div>
              <div className={styles.registContentLeftStepRight}>平台审核</div>
            </div>
            <img
              className={styles.registContentLeftStepImg}
              src="https://assets-oss.cbndata.com/cbndata-refactor-fe/FloenT65gzN4VrWYBJTBgO_GiyDG.png"
            />
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.registContentLeftStepCont)}>
              <div className={styles.registContentLeftStepIcon}>1</div>
              <div className={styles.registContentLeftStepText}>平台2-4个工作日通过邮件返回反馈结果</div>
            </div>
          </div>
          <div className={styles.registContentRight}>
            <div className={styles.registContentTitle}>立即申请入驻</div>
            <Form form={form} preserve={false}>
              <div className={styles.labelField}>
                <LabelField
                  name="companyName"
                  label="企业名称"
                  required
                  rules={[
                    { required: true, message: '请输入您的企业名称' },
                    {
                      async validator(_, value) {
                        if (
                          /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu.test(
                            value
                          ) ||
                          /^(\s+(.*)\s*)|(\s*(.*)\s+)$/.test(value)
                        ) {
                          return Promise.reject('请输入正确的企业名称');
                        } else if (
                          (/^(.*)\p{Unified_Ideograph}+(.*)$/u.test(value) && value.length >= 2) ||
                          (/^([A-Za-z0-9]*)|([A-Za-z0-9]+(\s)*[A-Za-z0-9])$/.test(value) && value.length >= 4)
                        ) {
                          return Promise.resolve();
                        } else if (
                          (/^(.*)\p{Unified_Ideograph}+(.*)$/u.test(value) && value.length < 2) ||
                          (/^([A-Za-z0-9]+((\w|\s)*)[A-Za-z0-9]+)|[A-Za-z0-9]+$/.test(value) && value.length < 4)
                        ) {
                          return Promise.reject('请输入完整的企业名称');
                        }
                        return Promise.reject('请输入正确的企业名称');
                      },
                    },
                  ]}
                >
                  <input className={styles.fieldInput} placeholder="请输入您的企业名称" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="companyEmail"
                  label="企业邮箱"
                  required
                  rules={[
                    { required: true, message: '请输入您的企业邮箱' },
                    { pattern: emailReg, message: '请输入正确的企业邮箱' },
                  ]}
                >
                  <input className={styles.fieldInput} placeholder="请输入您的企业邮箱" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="contactName"
                  label="姓名"
                  required
                  rules={[{ required: true, message: '请输入您的姓名' }]}
                >
                  <input className={styles.fieldInput} placeholder="请输入您的姓名" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="contactJob"
                  label="职务"
                  required
                  rules={[{ required: true, message: '请输入您的职务' }]}
                >
                  <input className={styles.fieldInput} placeholder="请输入您的职务" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <Field shouldUpdate>
                  {(_, __, { getFieldValue }) => {
                    return (
                      <div className={styles.phoneField}>
                        <LabelField
                          name="contactPhone"
                          label="手机号"
                          required
                          rules={[
                            { required: true, message: '请输入您的手机号' },
                            { pattern: isMobilePhone, message: '请输入正确的手机号' },
                          ]}
                        >
                          <input className={styles.fieldInput} placeholder="请输入您的手机号" />
                        </LabelField>
                        <div className={styles.countDown}>
                          <CountDown
                            theme="block"
                            canSend={getFieldValue('contactPhone') && isMobilePhone.test(getFieldValue('contactPhone'))}
                            onSend={() => {
                              sendCodeHandle({ phoneNum: getFieldValue('contactPhone') });
                            }}
                          />
                        </div>
                      </div>
                    );
                  }}
                </Field>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="validCode"
                  label="验证码"
                  required
                  rules={[{ required: true, message: '请输入验证码' }]}
                >
                  <input className={styles.fieldInput} placeholder="请输入验证码" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="companyWebsite"
                  label="官网地址"
                  //   required
                  //   rules={[{ required: true, message: '请输入官网地址' }]}
                >
                  <input className={styles.fieldInput} placeholder="请输入您的官网地址" />
                </LabelField>
              </div>
              <div className={styles.labelField}>
                <LabelField
                  name="wechatImg"
                  label="客服微信"
                  //   required
                  //   rules={[{ required: true, message: '请输入官网地址' }]}
                >
                  {/* <div className={styles.fieldUpload}> */}
                  <Upload accept="image/*">
                    <Button type="default" style={{ backgroundColor: '#fff', width: '120px', height: '40px' }}>
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-publish"></use>
                      </svg>
                      <span style={{ marginLeft: '5px' }}>点击上传</span>
                    </Button>
                  </Upload>
                  {/* </div> */}
                </LabelField>
              </div>
              <Field shouldUpdate>
                {(_, __, { getFieldValue, getFieldsError, isFieldsTouched }) => {
                  const isAllTouched =
                    isFieldsTouched(
                      ['companyName', 'companyEmail', 'contactName', 'contactJob', 'contactPhone', 'validCode'],
                      true
                    ) && getFieldValue('select') === true;
                  // isMobilePhone.test(getFieldValue('contactPhone'));

                  const hasErrors = !!getFieldsError().filter(({ errors }) => errors.length).length;
                  return (
                    <button
                      className={styles.submitBtn}
                      type="submit"
                      disabled={!isAllTouched || hasErrors}
                      onClick={submit}
                    >
                      {loading ? (
                        <ReactLoading type="spinningBubbles" width="20px" height="20px" className={styles.loadingImg} />
                      ) : (
                        <span>提交</span>
                      )}
                    </button>
                  );
                }}
              </Field>
              <>
                <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.userProtocol)}>
                  <Field name="select">
                    <Checkbox />
                  </Field>
                  <div className={styles.protocolText}>我已阅读并同意</div>
                  &nbsp;
                  <a href="/protocol/cooperation" target="_blank" className={styles.protocolLink}>
                    平台合作协议
                  </a>
                  &nbsp;
                  <a href="/register_agreement" target="_blank" className={styles.protocolLink}>
                    注册协议
                  </a>
                  &nbsp;
                  <a href="/privacy" target="_blank" className={styles.protocolLink}>
                    隐私协议
                  </a>
                </div>
                <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.userProtocol)}>
                  * 未注册手机验证后自动注册
                </div>
              </>
            </Form>
          </div>
        </div>
        <section className={styles.productListSection}></section>
      </div>
    </Layout>
  );
}

export default InstitutionSettled;
